import { render, staticRenderFns } from "./activityIcon.vue?vue&type=template&id=b76bcc16&"
import script from "./activityIcon.vue?vue&type=script&lang=js&"
export * from "./activityIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports